import { pathToUrl } from '@domain/routes/urls';

export interface Species {
  shape: string;
  species: string;
  fish_id: number;
  fishbrain_ids?: string[];
  edibility: string;
  synonyms: string[];
  species_report_only: number;
}

interface Result {
  success: boolean;
  results: Species[];
  message?: string;
}

export async function getSpeciesById(
  { fishrulesSpeciesId }: { fishrulesSpeciesId: number },
  signal: AbortSignal,
): Promise<Result> {
  const response = await fetch(pathToUrl('/api/_fishrules/get-species-by-id'), {
    body: JSON.stringify({ fishrulesSpeciesId }),
    method: 'POST',
    signal,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
  const json: Result = await response.json();
  return json;
}
